import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { catchError, of, map, Observable } from 'rxjs';

import { GET_COUNTRY_PHONE_INFO } from './graphql/queries';
import { ToastService } from '@core-services/toast.service';
import { CountryPhoneInfo } from 'app/graphql/graphql';

@Injectable({ providedIn: 'root' })
export class PhoneApiService {
    readonly apollo = inject(Apollo);
    readonly toastService = inject(ToastService);

    public loadCountryPhoneInfo(): Observable<CountryPhoneInfo[]> {
        return this.apollo.query({ query: GET_COUNTRY_PHONE_INFO, fetchPolicy: 'network-only' }).pipe(
            map(response => {
                if (response.error == null && response.errors == null) {
                    return response.data.supportedCountries as unknown as CountryPhoneInfo[];
                }

                this.toastService.showServerError('PHONES.LOADING_ERROR');
                console.error('Failed to load country phone info', response.error ?? response.errors[0].message);

                return [];
            }),
            catchError((error) => {
                console.error('Failed to load country phone info', error);

                return of(null);
            })
        );
    }
}
